module.exports = __webpack_public_path__ + "6908c1fb96066a663a192320288cd08c.svg";